<template>
  <div>
    <Nav></Nav>
    <PageHeader>
      <ZoneRole
        :need-toast="true"
        :onSelectRole="onSelectRole"
        ref="indexZoneRoleComponent"
        v-if="loginState.openid"
      ></ZoneRole>
    </PageHeader>
    <div class="main">
      <ProductInfo
        :clickDirectPay="clickDirectPay"
        :openTuanPrompt="openTuanPrompt"
        :showPriceInfo="true"
      ></ProductInfo>
      <div @click="goToStrangerGroup" class="none_team_tip">
        <span>找不到团友? 参加其他用户的团吧~ >></span>
      </div>
      <Rule></Rule>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"

import PageHeader from "./component/PageHeader.vue"
import ZoneRole from "./component/ZoneRole.vue"
import ProductInfo from "./component/ProductInfo.vue"
import Rule from "./component/Rule.vue"
import Nav from "./component/Nav.vue"
import tuanMixin from "./component/mixin.js"

let configs = window.__midasStaticConfig_wzry_tuan_config

export default {
  name: "Index",
  mixins: [tuanMixin],
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.initTuan()
    })
  },
  components: {
    PageHeader,
    ZoneRole,
    ProductInfo,
    Rule,
    Nav
  },
  data() {
    return {
      canSubmit: true
    }
  },
  computed: {
    ...mapGetters(["loginState"])
  },
  methods: {
    ...mapActions([
      "getLoginState",
      "reportUserAction",
      "setOnShareHandler",
      "getMyGroup",
      "setLoadingStart",
      "setLoadingEnd",
      "closePageLoading"
    ]),
    initTuan() {
      return this.getLoginState()
        .then(() => {
          this.closePageLoading()

          this.setLoadingStart()
          this.canSubmit = false

          return Promise.all([this.getMyGroup(), this.$refs.indexZoneRoleComponent.initZoneAndRole()])
        })
        .then(([myGroupList]) => {
          this.setLoadingEnd()
          this.canSubmit = true

          let selfTuanId = this.getSelfTuanId({ tuanRes: myGroupList, zoneId: this.selectedZone ? this.selectedZone.zone_id : 1 })

          if (selfTuanId) {
            // 跳转团详情
            this.$router.replace(`/group-detail/${selfTuanId}`)
            return
          } else {
            setTimeout(() => {
              this.setOnShareHandler()

              this.reportUserAction({
                iformat: configs.REPORT.PAGEVIEW.INDEX_SHOW
              })
            }, 0)
          }
        })
        .catch(error => {
          this.closePageLoading()

          this.setLoadingEnd()
          this.canSubmit = true

          this.catchInitError(error)
        })
    },

    // 用户变更完大区角色后，需要重新判断当前大区下有无小团，如果有就跳转到详情页
    onSelectRole() {
      this.setLoadingStart()
      this.canSubmit = false

      return this.getMyGroup()
        .then(myGroupList => {
          this.setLoadingEnd()
          this.canSubmit = true

          let selfTuanId = this.getSelfTuanId({ tuanRes: myGroupList, zoneId: this.selectedZone.zone_id, allStatus: true })
          if (selfTuanId) {
            // 跳转团详情
            this.$router.replace(`/group-detail/${selfTuanId}`)
            return
          }
        })
        .catch(error => {
          this.setLoadingEnd()
          this.canSubmit = true

          this.catchInitError(error)
        })
    }
  }
}
</script>
